/**
 * The one line a site pastes to get the widget: the Install tab and the setup
 * wizard (TOADO-579) show the same text, so it is built in one place.
 */
export function widgetSnippet(origin: string, key: string): string {
  return `<script src="${origin}/widget/v1/loader.js" data-toado-key="${key}" async></script>`;
}
